import { Injectable } from "@angular/core";

interface ToolEntry {
  name: string;
  desc: string;
}

const REGISTRY: Record<string, ToolEntry> = {
  get_parcel_boundaries: { name: "Parcel Boundaries", desc: "Vector footprints of cadastral parcels" },
  fetch_orthophoto: { name: "Orthophoto Fetch", desc: "Latest high-resolution orthoimage" },
  get_imagery_metadata: { name: "Imagery Metadata", desc: "Capture dates, resolution, coverage info" },
  run_pipeline: { name: "Data Pipeline", desc: "Server-side processing output" },
  export_archive: { name: "Export Archive", desc: "Packaged data for offline use" },
  search_embeddings: { name: "Embeddings Search", desc: "Semantic similarity search" },
  get_imagery_search: { name: "Imagery Search", desc: "Search tiles by bounding box and filters" },
  get_dsm_coverage: { name: "DSM Coverage", desc: "Digital surface model coverage areas" },
  get_dtm_coverage: { name: "DTM Coverage", desc: "Digital terrain model coverage areas" },
  get_ortho_coverage: { name: "Ortho Coverage", desc: "Orthophoto coverage areas" },
  get_damage_assessment: { name: "Damage Assessment", desc: "Property damage evaluation results" },
  get_structure_info: { name: "Structure Info", desc: "Building structure metadata" },
  get_property_report: { name: "Property Report", desc: "Full property data report" },
};

/**
 * Maps raw MCP tool names to human-readable display names and descriptions.
 * Falls back to the raw name when not registered.
 */
@Injectable({ providedIn: "root" })
export class ToolNameRegistryService {
  /**
   * Returns the display entry for a tool name.
   * Falls back to `{ name: rawName, desc: '' }` for unknown tools.
   */
  getDisplayName(rawName: string): ToolEntry {
    return REGISTRY[rawName] ?? { name: rawName, desc: "" };
  }
}
